import { useRef } from "react";
import useGetImages from "../useGetImages";

const ProductModal = ({ setCartModal, id, productDetail }) => {
  const { image: uri } = useGetImages(
    "product_pictures",
    id,
    productDetail?.URUN_KOD
  );
  const modalRef = useRef();

  const handleModalClose = (e) => {
    if (!modalRef.current.contains(e.target)) setCartModal(false);
  };

  return (
    <div
      onClick={handleModalClose}
      className="z-51 bg-gray-900/70 fixed top-0 left-0 w-full h-full flex justify-center items-center p-4"
      style={{zIndex:51}}
    >
      <div
        ref={modalRef}
        className="w-[90%] flex flex-col md:flex-row justify-between items-center md:items-start max-w-[700px] m-auto p-6 md:p-8 bg-white rounded-lg shadow-2xl max-h-[90vh] overflow-y-auto"
      >
        {uri && (
          <div className="flex-shrink-0 w-full md:w-80">
            <img
              src={uri}
              alt="product image"
              className="object-cover w-full rounded-lg shadow-md"
            />
          </div>
        )}

        <div className="w-full md:ml-5 flex items-center md:items-start flex-col mt-4 md:mt-0">
          <h2 className="text-xl md:text-2xl font-bold text-zinc-800 mb-3 text-center md:text-left">
            {productDetail?.URUN_ADI}
          </h2>
          
          {productDetail?.URUN_ACIKLAMA && (
            <p className="text-zinc-600 text-sm md:text-base leading-relaxed text-center md:text-left mb-4">
              {productDetail?.URUN_ACIKLAMA}
            </p>
          )}

          {productDetail?.FIYATI && (
            <p className="text-lg md:text-xl font-bold text-zinc-800 mb-4">
              {productDetail?.FIYATI} ₺
            </p>
          )}

          <button
            onClick={() => setCartModal(false)}
            className="w-full mt-2 bg-[#fecc4c] hover:bg-[#e5b942] transition-colors text-white font-semibold p-3 rounded-lg shadow-md text-sm md:text-base"
          >
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
